import styled from '@emotion/styled';
import WithPreviewImage from '@comp/Question/WithPreviewImage/WithPreviewImage';
import useQuestion from '@cont/Quiz/Taking/Objective/Question/useQuestion';
import { useRouter } from 'next/router';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getQuizDetails } from '@selectors/quizTaking';
import { Spacings } from '@styles/index';
import Question from './Question/Question';
import SectionList from './SectionsList.jsx/SectionList';
import QuestionWithComprehension from './Question/QuestionWithComprehension';

const ContentWrapper = styled.div`
  height: calc(100vh - 184px);
  margin-top: ${Spacings.SPACING_8B};
`;

const QuestionView = () => {
  const { currentQuestion, currentLanguage } = useQuestion();
  const { query } = useRouter();
  const { quizUID } = query;

  const hasComprehension =
    !!currentQuestion?.comprehension?.[currentLanguage?.code];

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const isDefaultSectionPresent = quizDetails?.sections?.[0]?.is_default;

  const maxHeight = isDefaultSectionPresent
    ? 'calc(100vh - 178px)'
    : 'calc(100vh - 242px)';

  return (
    <ContentWrapper>
      {!isDefaultSectionPresent && <SectionList />}
      <WithPreviewImage>
        {hasComprehension ? (
          <QuestionWithComprehension maxHeight={maxHeight} />
        ) : (
          <Question maxHeight={maxHeight} />
        )}
      </WithPreviewImage>
    </ContentWrapper>
  );
};

export default QuestionView;
